import * as React from "react";
import { useConfigState } from "../../../context/settings/config";
import { useActions } from "../../../context/settings/config/useActions";
import { RuleSetting } from "../../../context/settings/types";

export function useProjectSettings(projectList: Insite.Project[]) {
  const configState = useConfigState();
  const { setSelectedRule, updateActiveProject, getProjectConfig } =
    useActions();
  const initialProject = projectList[0].jira_key;

  React.useEffect(() => {
    void updateActiveProject(initialProject);
  }, [projectList]);

  const handleProjectSelect = React.useCallback(function onProjectSelect(
    projectKey: string
  ) {
    return () => {
      void updateActiveProject(projectKey);
    };
  },
  []);

  React.useEffect(() => {
    if (configState.activeProject && !configState.isLoading) {
      void getProjectConfig(configState.activeProject, configState.insightType);
    }
  }, [configState.activeProject, configState.insightType]);

  const handleRuleSelect = React.useCallback(function onRuleSelect(rule: RuleSetting) {
    setSelectedRule(rule);
  }, []);

  return {
    handleProjectSelect,
    handleRuleSelect,
    isSaving: configState.isSaving,
    activeProject: configState.activeProject || initialProject,
    selectedRule: configState.selectedRule,
  };
}
